export const AdminRoutes = [
  { path: '', lazy: () => import('./pages/admin.$oid') },
  { path: 'checkin', lazy: () => import('./pages/admin.$oid.checkin') },
  // Event Dashboard
  { path: 'events', lazy: () => import('./pages/admin.$oid._events'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.events') },
      { path: 'calendar', lazy: () => import('./pages/admin.$oid.events.calendar'), },
      { path: 'analytics', lazy: () => import('./pages/admin.$oid.analytics'), },
      { path: 'report', lazy: () => import('./pages/admin.$oid.events.reports'), },
      { path: 'create', lazy: () => import('./pages/admin.$oid.events.create'), },
    ],
  },
  // Event Details
  { path: 'events/:pid',
    lazy: () => import('./pages/admin.$oid.events._$pid'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.events.$pid') },
      { path: 'settings', lazy: () => import('./pages/admin.$oid.events.$pid.settings'), },
      { path: 'attendees', lazy: () => import('./pages/admin.$oid.events.$pid.community'), },
      { path: 'scoring', lazy: () => import('./pages/admin.$oid.events.$pid.scoring'), },
      { path: 'purchases', lazy: () => import('./pages/admin.$oid.events.$pid.purchases'), },
      { path: 'history', lazy: () => import('./pages/admin.$oid.events.$pid.history'), },
    ],
  },
  // Community
  { path: 'community',
    lazy: () => import('./pages/admin.$oid._community'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.community.attendees') },
      // Notifications
      { path: 'notifications', lazy: () => import('./pages/admin.$oid.notifications') },
      { path: 'notifications/create', lazy: () => import('./pages/admin.$oid.notifications.templates.create') },
      { path: 'notifications', lazy: () => import('./pages/admin.$oid.notifications.templates.$id') },
      { path: 'notifications/:id', lazy: () => import('./pages/admin.$oid.notifications.templates.$id') },
      // Memberships
      { path: 'memberships', lazy: () => import('./pages/admin.$oid.memberships') },
      // Nested under _community so the create page renders inside
      // TabNavigationLayout, which shows the back arrow on create routes.
      { path: 'memberships/create', lazy: () => import('./pages/admin.$oid.memberships.create') },
    ],
  },
  { path: 'community/memberships',
    children: [
      { path: ':mid',
        lazy: () => import('./pages/admin.$oid.memberships._$mid'),
        children: [
          { path: 'settings', lazy: () => import('./pages/admin.$oid.memberships.$mid.settings') },
          { path: 'subscribers', lazy: () => import('./pages/admin.$oid.memberships.$mid.subscribers') },
          { path: 'history', lazy: () => import('./pages/admin.$oid.memberships.$mid.history') },
        ],
      }
    ]
  },
  // Dev-only: automation wizard unfinished; Vite statically replaces import.meta.env.DEV
  // so these tree-shake out of staging/prod bundles entirely.
  ...(import.meta.env.DEV
    ? [
        { path: 'automations', lazy: () => import('./pages/admin.$oid.automations') },
        { path: 'automations/create', lazy: () => import('./pages/admin.$oid.automations.create') },
        { path: 'automations/:aid', lazy: () => import('./pages/admin.$oid.automations.$aid') },
      ]
    : []),
  { path: 'schedule', lazy: () => import('./pages/admin.$oid.schedule') },
  { path: 'discounts', lazy: () => import('./pages/admin.$oid.discounts') },
  // Widgets
  { path: 'widgets', lazy: () => import('./pages/admin.$oid.widgets') },
  // Settings
  { path: 'settings',
    lazy: () => import('./pages/admin.$oid._settings'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.settings') },
      { path: 'usage', lazy: () => import('./pages/admin.$oid.settings.usage') },
    ]
  },
  { path: 'overview', lazy: () => import('./pages/admin.$oid.overview') },
  { path: 'updates', lazy: () => import('./pages/admin.$oid.updates') },
  { path: 'overview/transactions', lazy: () => import('./pages/admin.$oid.overview.transactions') },
  // Money
  {
    path: 'money',
    lazy: () => import('./pages/admin.$oid._money'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.money') },
      { path: 'purchases', lazy: () => import('./pages/admin.$oid.purchases') },
      { path: 'accounting', lazy: () => import('./pages/admin.$oid.accounting') },
    ],
  },
  // Staff
  { path: 'staff', lazy: () => import('./pages/admin.$oid._staff'),
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.staff') },
      { path: 'create', lazy: () => import('./pages/admin.$oid.staff.create') },
      { path: 'schedule', lazy: () => import('./pages/admin.$oid.staff.schedule') },
      { path: 'my-schedule', lazy: () => import('./pages/admin.$oid.staff.my-schedule') },
      { path: 'compensation-defaults', lazy: () => import('./pages/admin.$oid.staff.compensation-defaults') },
      { path: 'compensation', lazy: () => import('./pages/admin.$oid.compensation') }
    ],
  },
  { // Festivals List
    path: 'festivals',
    children: [
      { path: '', lazy: () => import('./pages/admin.$oid.festivals') },
      { path: 'create', lazy: () => import('./pages/admin.$oid.festivals.create') },
      // Single Festival
      { path: ':pid', lazy: () => import('./pages/admin.$oid.festivals._$pid'),
        children: [
          { path: '', lazy: () => import('./pages/admin.$oid.festivals.$pid') },
          { path: 'settings', lazy: () => import('./pages/admin.$oid.festivals.$pid.settings') },
          { path: 'schedule', lazy: () => import('./pages/admin.$oid.festivals.$pid.schedule') },
          { path: 'attendees', lazy: () => import('./pages/admin.$oid.festivals.$pid.attendees') },
          { path: 'purchases', lazy: () => import('./pages/admin.$oid.festivals.$pid.purchases') },
          { path: 'analytics', lazy: () => import('./pages/admin.$oid.festivals.$pid.analytics') },
          { path: 'contests', lazy: () => import('./pages/admin.$oid.festivals.$pid.contests') },
          { path: 'history', lazy: () => import('./pages/admin.$oid.festivals.$pid.history') },
        ],
      },
    ],
  },
]
